export default __webpack_public_path__ + "static/media/fund.5b5d13ba.jpeg";